import { faqItems } from '@/mocks/homeData';

export default function FaqSection() {
  return (
    <section id="faq" className="py-12 md:py-16 bg-background-100">
      <div className="section-container">
        <div className="text-center mb-8 md:mb-10">
          <h2 className="section-title">常见问题</h2>
          <p className="section-subtitle">关于91吃瓜爆料，你想知道的都在这里</p>
        </div>

        <div className="max-w-3xl mx-auto space-y-3">
          {faqItems.map((item) => (
            <div
              key={item.id}
              className="bg-background-50 rounded-xl border border-background-200/70 p-5 md:p-6"
            >
              <h3 className="text-base md:text-lg font-semibold text-foreground-900 mb-2 flex items-start gap-2">
                <span className="text-primary-500 flex-shrink-0 mt-0.5">
                  <i className="ri-question-answer-line"></i>
                </span>
                {item.question}
              </h3>
              <p className="text-sm md:text-base text-foreground-600 leading-relaxed pl-6">
                {item.answer}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}